import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { __, setTableParams } from '../../../../core/utils';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/canvas_editor';
import Button from '../Toolbar/Button';
import PlanIcon from '../../images/Icon20_Plan.svg';
import { listPlanVersionPlans } from '../../../../redux/actions/table/working_set_plans';
import { listPlanRevisionPlans } from '../../../../redux/actions/table/current_set_plans';

const Plan = ({
  canvas_editor: { viewer, fabricOverlay },
  isActive,
  table,
  source,
  user_id,
  match,
}) => {
  const table_name =
    match.path == '/plans/revisions/:plan_revision'
      ? 'current_set_plans'
      : 'working_set_plans';

  table = table[table_name];

  useEffect(() => {
    if (!isActive || !fabricOverlay) return;

    const canvas = fabricOverlay.fabricCanvas();

    canvas.defaultCursor = 'crosshair';
    // canvas.defaultCursor = `url(${TaskCursorIcon}) 10 22, auto`;
    // canvas.hoverCursor = 'crosshair';

    setCursorTooltip(__('canvas.tooltip.plan'));

    canvas.getObjects().forEach((obj) => {
      obj.selectable = false;
      obj.evented = false;
    });

    function onMouseDown(options) {
      if (options.target || !isActive) return;

      const rawPointer = canvas.getPointer(options.e);

      const x = rawPointer.x;
      const y = rawPointer.y;

      viewer.setMouseNavEnabled(true);

      if (x < 0 || x > source.width || y < 0 || y > source.height) {
        return;
      }

      setTableParams(table_name, {
        x,
        y,
        attach_plan_wizard: true,
        stage_id: source.stage_id,
      });
    }

    const onPointerDown = (e) => {
      viewer.setMouseNavEnabled(false);
    };

    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);

    canvas.on('mouse:down', onMouseDown);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);
    };
  }, [fabricOverlay, isActive]);

  const createPlan = (x, y, planID, uid, old_plan_id) => {
    const canvas = fabricOverlay.fabricCanvas();

    if (old_plan_id) {
      canvas.remove(
        ...canvas.getObjects().filter((obj) => obj.planID === old_plan_id)
      );
    }

    const background = new fabric.Path(
      'M64 32 A32 32 0 1 1 0 32 A32 32 0 1 1 64 32 Z',
      {
        fill: 'rgba(255, 0, 0, 0.33)',
        stroke: null,
        strokeWidth: 0,
        selectable: false,
        evented: false,
      }
    );

    const foreground = new fabric.Path(
      'M36.2003 24.4685 L27.8003 31.1325 ' +
        'M11.0003 37.8902 L28.5199 51.7894 ' +
        'C30.5583 53.4048 33.4422 53.4048 35.4806 51.7894 ' +
        'L53.0003 37.8902 ' +
        'M20.4338 18.6264 L24.6338 21.9584 ' +
        'M32.0003 27.8003 L43.567 36.9731 ' +
        'M20.4338 18.6264 L12.325 25.058 ' +
        'C10.5581 26.4579 10.5581 29.1404 12.325 30.5432 ' +
        'L28.5202 43.3894 ' +
        'C30.5586 45.0051 33.4426 45.0051 35.481 43.3894 ' +
        'L51.6762 30.5432 ' +
        'C53.4429 29.1404 53.4429 26.4579 51.6762 25.058 ' +
        'L35.481 12.2116 ' +
        'C34.4618 11.4052 33.2298 10.9992 32.0006 10.9992',
      {
        fill: 'transparent',
        stroke: '#000000',
        strokeWidth: 3.2,
        strokeLineCap: 'round',
        strokeLineJoin: 'round',
        selectable: false,
        evented: false,
      }
    );

    const obj = new fabric.Group([background, foreground], {
      originX: 'left',
      originY: 'top',
    });

    obj.set({
      left: x,
      top: y,
      objectType: 'plan',
      originalLeft: x,
      originalTop: y,
      planID: planID,
      userID: uid,

      //moving: false,
      lockScalingX: true,
      lockScalingY: true,
      // lockMovementX: lockmov,
      // lockMovementY: lockmov,
      hasControls: false,
      hasBorders: false,
    });

    obj.setCoords();

    if (table_name === 'current_set_plans') {
      listPlanRevisionPlans(match.params.plan_revision);
    } else listPlanVersionPlans(match.params.plan_version);

    canvas.add(obj);

    viewer.setMouseNavEnabled(true);
  };

  useEffect(() => {
    if (table.plan_id) {
      createPlan(table.x, table.y, table.plan_id, user_id, table.old_plan_id);

      setTableParams(table_name, {
        plan_id: undefined,
        x: undefined,
        y: undefined,
        old_plan_id: undefined,
      });
    }
  }, [table?.plan_id]);

  const toggleTool = () => {
    updateTool({ tool: 'plan' });
  };

  return (
    <Button
      id='plan'
      label={__('canvas.toolbar.plan')}
      icon={PlanIcon}
      active={isActive}
      onClick={toggleTool}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    table: state.table,
    user_id: state.auth.id,
  };
};

export default withRouter(connect(mapStateToProps, null)(Plan));
